export default "__VITE_ASSET__e0735b5f__"